import React, {useContext, useState} from "react";
import {BiChat, BiLinkExternal, BiUser} from "react-icons/bi";
import {Modal} from "react-bootstrap";
import {UserChatMessage, usersService} from "services";
import {AuthContext} from "contexts";
import {ModerationUserTag} from "interfaces";
import {ModerationChat} from "components/ModerationUserCard/components/ModerationChats/ModerationChat";
import {getAbuseWords} from "utils/getAbuseWords";
import {Genders} from "enums";

export const ModerationChatModal: React.FC<{
    userKey: string;
    tag: ModerationUserTag,
    userName: string,
    userGender: Genders
}>
    = ({userName, userKey, tag, userGender}) => {
    const {env} = useContext(AuthContext);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [data, setData] = useState<UserChatMessage[] | null>(null);

    const abuseWords = getAbuseWords(tag?.info ?? '');

    const handleClose = () => {
        setData(null)
        setIsModalVisible(false)
    }

    const handleOpen = async () => {
        if (!env || !tag.infoValue) {
            return
        }

        const chat = await usersService.getChat(env, {user1: tag.infoValue, user2: userKey})
        if (chat) {
            setData(chat)
            setIsModalVisible(true)
        }
    }

    if (!tag.infoValue) {
        return <small className="mx-2 text-muted badge bg-secondary">Чат удален</small>
    }

    return <>
        <div className="d-flex flex-row">
            <a className="mx-2 d-flex align-items-center text-black-50" style={{cursor: 'pointer'}}
               onClick={handleOpen}>
                <BiChat size={16} className="mx-1"/> Чат
            </a>
            <a href={`profile/${tag.infoValue}`} target="_blank" rel="noreferrer"
               className="mx-2 d-flex align-items-center text-black-50" style={{cursor: 'pointer'}}>
                <BiUser size={16} className="mx-1"/> Собеседник
            </a>
        </div>
        <Modal show={isModalVisible} onHide={handleClose} className="modal-90vh">
            <Modal.Header closeButton className="d-flex flex-row">
                <Modal.Title>Чат</Modal.Title>
                <a href={`profile/${tag.infoValue}`} target="_blank" rel="noreferrer"
                   className="mx-2 d-flex align-items-center text-black-50 mt-1"
                   style={{cursor: 'pointer'}}>
                    <BiLinkExternal size={16} className="mx-1"/> Собеседник
                </a>
            </Modal.Header>
            <Modal.Body className="modal-body-scroll">
                {data &&
                    <ModerationChat
                        abuseWords={abuseWords}
                        userName={userName}
                        userGender={userGender}
                        userKey={userKey}
                        messages={data}
                        isMyMessageInverted={true}
                        hasAbuseJumps={true}/>
                }
            </Modal.Body>
        </Modal>
    </>
}